class ConsoleLogger {
  _meta

  constructor (meta = {}) {
    this._meta = Object.assign(meta || {}, {
      // NODE_ENV: process.env.NODE_ENV,
      // APP_VERSION: process.env.VUE_APP_VERSION
    })
  }

  debug (message, ...optionalParams) {
    console.debug(message, this._meta, ...optionalParams)
  }

  error (message, ...optionalParams) {
    console.error(message, this._meta, ...optionalParams)
  }

  info (message, ...optionalParams) {
    console.info(message, this._meta, ...optionalParams)
  }

  log (message, ...optionalParams) {
    console.log(message, this._meta, ...optionalParams)
  }

  warn (message, ...optionalParams) {
    console.warn(message, this._meta, ...optionalParams)
  }
}

const logger = new ConsoleLogger()

export default logger
